'use client';

import dynamic from 'next/dynamic';

const ImageCompare = dynamic(() => import('./ImageCompare'));

export default ImageCompare;
